<template>
  <div class='EnbLogo' @click="push">
    <img :src="Logo">
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'EnbLogo',
  computed: {
    ...mapGetters(['Logo'])
  },
  methods: {
    ...mapActions(['GetStoreProducts', 'Loading']),
    push () {
      this.Loading(true)
      this.$router.push(`/site`)  
      this.GetStoreProducts({ params: { last: [], limit: 8, categoria: '' }, init: true })
        .then(() => this.Loading(false))
    }
  }
}
</script>

<style scoped>
.EnbLogo {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  width: 260px;
  height: 80px;
  cursor: pointer;
}
</style>
